/**
 *  @class
 *  @function FreeShipping
 */

if (!customElements.get('free-shipping')) {
  class FreeShipping extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      // Element där beloppet ska in
      let amount_text = this.querySelector('.free-shipping--text span');

      // Totalt & minimum i subenheter (öre/cent)
      let total = parseInt(this.dataset.cartTotal, 10) || 0;
      let minimum = parseInt(this.dataset.minimum, 10) || 0;

      // Om ingen threshold satt – gör inget
      if (!minimum || minimum <= 0) {
        this.style.setProperty('--percentage', 0);
        return;
      }

      let percentage = total / minimum;
      if (percentage > 1) {
        percentage = 1;
      } else if (percentage < 0) {
        percentage = 0;
      }

      this.remainingText = this.querySelector('.free-shipping--text-remaining');
      this.fullText = this.querySelector('.free-shipping--text-full');

      if (total < minimum) {
        // Kunden är UNDER gränsen → visa "spend more"-text
        if (amount_text) {
          let remaining = minimum - total;
          let format =
            (window.theme && window.theme.settings && window.theme.settings.money_with_currency_format) ||
            (window.Shopify && window.Shopify.money_format) ||
            "${{amount}}";

          amount_text.innerHTML = formatMoney(remaining, format);
        }

        if (this.remainingText) {
          this.remainingText.style.display = 'block';
        }
        if (this.fullText) {
          this.fullText.style.display = 'none';
        }
      } else {
        // Kunden ÄR över tröskeln → visa "FREE shipping"-text
        if (this.remainingText) {
          this.remainingText.style.display = 'none';
        }
        if (this.fullText) {
          this.fullText.style.display = 'block';
        }
      }

      // Sätt CSS-variabel för animation/width
      this.style.setProperty('--percentage', percentage);
    }
  }

  customElements.define('free-shipping', FreeShipping);
}
